import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {SelectElement} from './select.model';
import {FormUtils} from '../../../shared/utils/form.utils';
import {DomSanitizer} from "@angular/platform-browser";


@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
})
export class SelectComponent implements OnInit, OnChanges, AfterViewInit {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() elements: SelectElement[] = [];
    @Input() disabled = false;
    @Input() displayNoValue = false;
    @Input() loading = false;
    @Input('noValueLabel') private pNoValueLabel: string;
    @Input() deletable = false;

    @Output() singleSelectionChanged = new EventEmitter<SelectElement>();

    selectedElement: SelectElement;
    eraseSelectionEnabled;

    constructor(public sanitizer: DomSanitizer) {

    }

    ngAfterViewInit(): void {
        if (this.parentFormGroup && this.parentFormControlName) {
            this.onSelectionChange(this.parentFormGroup.get(this.parentFormControlName)?.value);
        }
    }



    ngOnChanges(changes: SimpleChanges): void {
        if (changes['parentFormGroup'] || changes['parentFormControlName']) {
            if (this.parentFormControlName && this.parentFormGroup) {
                this.parentFormGroup.controls[this.parentFormControlName].valueChanges.subscribe(value => {
                    this.onSelectionChange(value, true);
                });
            }
        }
        if (changes['elements']) {
            this.elements?.forEach(value => value.html = this.sanitizer.bypassSecurityTrustHtml(value.label));
            this.onSelectionChange(this.parentFormGroup.get(this.parentFormControlName)?.value);
        }
    }

    onSelectionChange(value: any, triggered: boolean = false) {
        this.selectedElement = undefined;
        // console.log('onSelectionChange', value, this.elements);
        if (value && this.elements) {
            this.selectedElement = this.elements.find(item => item.value === value)
        }
        if (triggered){
            this.singleSelectionChanged.next(this.selectedElement);
        }
    }

    get elementControl() {
        return this.parentFormGroup.get(this.parentFormControlName);
    }

    get noValueLabel() {
        return this.pNoValueLabel ? this.pNoValueLabel : 'Aucune valeur';
    }

    eraseSelection() {
        this.elementControl.setValue(null);
    }

    ngOnInit(): void {
        this.eraseSelectionEnabled = this.deletable && !FormUtils.isRequiredField(this.elementControl);
    }
}
